var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-btn",
        {
          staticClass: "btn btn-card-action btn-card-action-light my-1",
          attrs: { id: _vm.id },
          on: {
            click: function ($event) {
              _vm.showDeleteModal = true
            },
          },
        },
        [_vm._v("Удалить")]
      ),
      _c(
        "b-modal",
        {
          attrs: {
            title: "Удалить закупку",
            centered: "",
            "no-close-on-backdrop": "",
            "no-close-on-esc": "",
          },
          on: { hide: _vm.onHide },
          scopedSlots: _vm._u([
            {
              key: "modal-header-close",
              fn: function () {
                return [_c("button-close-modal")]
              },
              proxy: true,
            },
            {
              key: "modal-footer",
              fn: function () {
                return [
                  _c(
                    "b-overlay",
                    {
                      staticClass: "d-inline-block",
                      attrs: {
                        show: _vm.isLoading,
                        opacity: "0.6",
                        rounded: "",
                        "spinner-small": "",
                        "spinner-variant": "primary",
                      },
                    },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: { variant: "custom-outline-secondary" },
                          on: { click: _vm.onHide },
                        },
                        [_vm._v("Отмена ")]
                      ),
                      _vm._v("  "),
                    ],
                    1
                  ),
                  _c(
                    "b-overlay",
                    {
                      staticClass: "d-inline-block",
                      attrs: {
                        show: _vm.isLoading,
                        opacity: "0.6",
                        rounded: "",
                        "spinner-small": "",
                        "spinner-variant": "primary",
                      },
                    },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: { variant: "custom-danger" },
                          on: { click: _vm.onDelete },
                        },
                        [_vm._v("Подтвердить")]
                      ),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ]),
          model: {
            value: _vm.showDeleteModal,
            callback: function ($$v) {
              _vm.showDeleteModal = $$v
            },
            expression: "showDeleteModal",
          },
        },
        [
          _c("div", { staticClass: "d-block text-left" }, [
            _c("p", [
              _vm._v(
                "Вы действительно хотите удалить закупку " +
                  _vm._s(_vm.contract.reg_number) +
                  "?"
              ),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }